// api
import type { PostEnergyGroupDto } from '@/api/generated/recalc/endpoints/v2/energyGroups';
import type { LocationDto } from '@/api/generated/recalc/endpoints/v2/locations';

// shared components
import { EMPTY_ADDRESS_VALUE } from '@/components/ui/form';

// relative
import type { CreateEnergyGroupFormValues } from './createEnergyGroupForm.schema';

export function toCreateEnergyGroupFormValues(): CreateEnergyGroupFormValues {
  return {
    name: '',
    type: 'Power',
    location: EMPTY_ADDRESS_VALUE,
  };
}

export function toLocationDto(
  values: CreateEnergyGroupFormValues,
  accountId: number,
): LocationDto {
  // Safe cast: zod's `.refine()` on `location` guarantees `latitude`/
  // `longitude` are finite numbers by the time this mapper runs (only ever
  // called from the submit handler, after validation has passed).
  return {
    ...values.location,
    latitude: values.location.latitude as number,
    longitude: values.location.longitude as number,
    accountId,
  };
}

export function toPostEnergyGroupDto(
  values: CreateEnergyGroupFormValues,
  accountId: number,
  locationId: number,
): PostEnergyGroupDto {
  return {
    accountId,
    name: values.name.trim(),
    type: values.type,
    locationId,
    options: {
      state: 'New',
      isDraftMode: false,
    },
  };
}
